import styled from "styled-components";
import { colors } from "theme";

export const CardOption = styled.div`
  width: ${({ fullWidth }) => (fullWidth ? "100%" : "24%")};
  padding: 14px;
  text-align: center;
  user-select: none;
  border: 1px solid ${colors.primaryColor};
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-family: inter;
  background-color: ${(props) =>
    props.selected ? colors.primaryColor : "transparent"};
  color: ${(props) =>
    props.selected ? colors.whiteColor : colors.primaryColor};
  transition: 0.2s ease-in-out all;
  /* &:hover {
    background-color: ${(props) =>
    props.selected ? "none" : colors.cardBackgroundColor};
    border: 1px solid
      ${(props) => (props.selected ? colors.baseBlue : colors.accentColor)};
    transform: scale(1.015);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
  } */
`;

export const CardSelectorWrapper = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
`;
